import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { fundRaiserPageAction } from '../../store/actions';
import { SINGLE_OWNER_PAGE, TEAM_PAGE } from '../../constants';
import { TopPagesAndTeams } from '../../components/TopPagesAndTeams';

export default function () {
    const dispatch = useDispatch();

    const campaignDetails = useSelector(state => state.fundraiser_page.campaign_details);
    const topCampaignTeamFundraisers = useSelector(state => state.fundraiser_page.top_teams_impacted);
    const topCampaignFundraisers = useSelector(state => state.fundraiser_page.top_fundraisers_impacted);

    useEffect(() => {
        dispatch(fundRaiserPageAction.getTopFundraisersByImpact(TEAM_PAGE, campaignDetails?.event_id));
        dispatch(fundRaiserPageAction.getTopFundraisersByImpact(SINGLE_OWNER_PAGE, campaignDetails?.event_id));
    }, []);

    return <TopPagesAndTeams topPages={topCampaignFundraisers} topTeams={topCampaignTeamFundraisers} />
}